import {BaseService} from "./base.service";

class CitiesService extends BaseService {

    constructor() {
        super('api/cities')
    }

    getCityByName(nameCity) {
        return this.http.get(`api/get-city-by-name/${nameCity}`).then(response => response.data).catch(err => err.message);;
    }


}

export const citiesService = new CitiesService();
